import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { navSelector } from '../../../sites/aflm/store/js/modules/competition-nav/selectors';

export const useIsBettingSuppressed = (
    bettingData,
    competitionId,
    activeRounds
) => {
    const [suppressBetting, setSuppressBetting] = useState(false);
    const nav = useSelector(navSelector);

    useEffect(() => {
        setSuppressBetting(
            PULSE.app.common.betting.isBettingSuppressionEnabled()
        );

        // Event to suppress betting on the site
        document.addEventListener(
            PULSE.app.common.CONSTANTS.EVENTS.BETTING.HIDE,
            () => {
                setSuppressBetting(true);
            }
        );

        // Event to show betting odds on the site
        document.addEventListener(
            PULSE.app.common.CONSTANTS.EVENTS.BETTING.SHOW,
            () => {
                setSuppressBetting(false);
            }
        );
    }, []);

    if (suppressBetting) {
        return true;
    }

    if (bettingData && !bettingData.competition.displayInAppIOS) {
        return true;
    }

    if (
        competitionId &&
        competitionId !== PULSE.app.common.CONSTANTS.PROVIDER_IDS.PREMIERSHIP
    ) {
        return true;
    }

    if (activeRounds && !activeRounds.includes(nav?.round.roundNumber)) {
        return true;
    }

    return false;
};
